import React from 'react'
import ReactDOM from 'react-dom/client'
// First, so the install prompt is caught even if it fires before React mounts.
import './lib/install'
import { applyStoredConsent } from './lib/consent'
import App from './App'
import './index.css'

applyStoredConsent()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
